<template>
  <el-dialog :visible.sync="show" width="30%">

    <p v-for="(item, index) in content" :key="index" style="margin: 10px 0;">{{index+1}}.{{item}}</p>

    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false" type="primary">知道了</el-button>
    </span>

  </el-dialog>
</template>
<script>
  var _this;
  import axios from 'axios'; // AJAX封装类
  export default {
    props: {
      'isShow': Boolean,
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        // axios.get('https://www.kancloud.cn/book/guankuoapp/jiuzhouadmin/edit').then((response) => {
        //   // this.htmlMD = response.data;
        //   console.log(response.data);

        // });

        //  _this.$post(
        //     "/driver/addDriverSubmit",
        //     _this.submit_data,
        //     _this.submit_rules
        //   )
        //   .then(res => {

        //     // 触发父组件自定义事件刷新表格
        //     _this.$emit('onSubmit');
        //     _this.closeDialog();
        //     this.$message.success(res.msg);
        //   }).catch(res => {

        //   })

      },
    },
    created() {
      _this = this;
    },
    data() {
      return {


        show: false,

        content: [

          '订单监控页面增加已完成行程更改支付方式及金额功能',
          '订单监控页面中的查看组件增加了实时查看司机位置及状态信息',
          '修复了后台销单之后列表页面不刷新的bug',
          '修改了派单成功之后文字排列问题',
          '订单监控页面增加查看乘客账户金额'

        ]



      };
    },

    methods: {



    },
  };
</script>
<style>

</style>